import { render } from "./ColumnSpacing.vue?vue&type=template&id=58638521&scoped=true&ts=true"
import script from "./ColumnSpacing.vue?vue&type=script&lang=ts"
export * from "./ColumnSpacing.vue?vue&type=script&lang=ts"

import "./ColumnSpacing.vue?vue&type=style&index=0&id=58638521&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58638521"]])

export default __exports__